@for (document of documents(); track document) {
  <div
    class="item"
    tabindex="-1"
    (click)="form() ? edit($index) : showFiles(document.attachments)"
    (keydown)="(null)"
  >
    <onyx-icon
      class="icon"
      name="document-filled"
      [size]="16"
      [frame]="24"
    ></onyx-icon>

    <p class="f-body-l f-medium">{{ document.name }}</p>

    <p class="note f-body-l f-medium">{{ document.note }}</p>

    <div class="options">
      <onyx-icon-button
        variant="ghost"
        color="black"
        [size]="32"
        icon="download-outlined"
        [circle]="true"
        onyxTooltip="labels.download"
        (click)="
          download(form() ? $index : undefined, document);
          $event.stopPropagation()
        "
      ></onyx-icon-button>

      @if (canEdit(document)) {
        <onyx-icon-button
          variant="ghost"
          color="black"
          [size]="32"
          icon="edit-outlined"
          [circle]="true"
          onyxTooltip="labels.edit"
          (click)="edit($index); $event.stopPropagation()"
        ></onyx-icon-button>
      }

      @if (form()) {
        <onyx-icon-button
          variant="ghost"
          color="black"
          [size]="32"
          icon="delete-outlined"
          [circle]="true"
          onyxTooltip="labels.delete"
          (click)="remove($index); $event.stopPropagation()"
        ></onyx-icon-button>
      }
    </div>
  </div>
} @empty {
  @if (placeholder(); as placeholder) {
    <p class="item empty f-body-m f-medium">
      {{ placeholder | translate }}
    </p>
  }
}
